import { render, staticRenderFns } from "./ProjetoPage.vue?vue&type=template&id=7dd85984"
import script from "./ProjetoPage.vue?vue&type=script&lang=js"
export * from "./ProjetoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports